export interface NewRadioProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: React.ReactNode;
  labelClassName?: string;
  invalid?: boolean;
  /** Colours the label text Bombiix Blue (#6DC1F5); box chrome unchanged. */
  isHighlight?: boolean;
}

/**
 * NewRadio — Bombiix master-design radio button (Figma node 5334:180215).
 * 20px circle rendered from src/assets/icons/radio-{unchecked,checked}.svg via
 * the `.bombiix-radio*` classes in _radio.scss. Component only wires classes +
 * native input behaviour; feature/props remain untouched.
 */
function NewRadio({ label, labelClassName, className, id, invalid, isHighlight, ...rest }: NewRadioProps) {
  const inputClass = ['bombiix-radio__input', className].filter(Boolean).join(' ');
  const labelClass = ['bombiix-radio__label', labelClassName].filter(Boolean).join(' ');
  const rootClass = ['bombiix-radio', invalid ? 'bombiix-radio--invalid' : '', isHighlight ? 'bombiix-radio--bulk' : '']
    .filter(Boolean)
    .join(' ');
  return (
    <label className={rootClass} htmlFor={id}>
      <input type="radio" id={id} className={inputClass} {...rest} />
      <span className="bombiix-radio__box" aria-hidden="true" />
      {label !== undefined ? <span className={labelClass}>{label}</span> : null}
    </label>
  );
}

export default NewRadio;
